import React, { useState } from "react";
import PropTypes from "prop-types";
import LoginForm from "../../components/LoginForm";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { actions } from "../../modules/auth";
import { Link } from "react-router-dom";

const propTypes = {
  login: PropTypes.func.isRequired,
  authenticating: PropTypes.bool.isRequired,
  failAuth: PropTypes.string
};

const Login = (props) => {
  const onSubmit = async values => {
    const {
      login,
      location,
      history: { push }
    } = props;
    const { response } = await login(values);
    if (response) {
      if (response.data.sid) {
        setInitialValues({
          email: response.data.phone_number,
          password: "",
          sid: response.data.sid
        })
        setSmsLogin(true);
      } else {
        const next = location.search.includes("?next=")
          ? location.search.substr(6)
          : "/contracts";
        push(next);
      }
    }
  };
  const resendCode = async values => {
    setSmsLogin(false)
  }
  const { authenticating, failAuth } = props;
  const [smsLogin, setSmsLogin] = useState(false); 
    const [initialValues, setInitialValues] = useState({
    email: "",
    password: "",
  })
    return (
      <div className="login">
        <LoginForm
          authenticating={authenticating}
          failAuth={failAuth}
          onSubmit={onSubmit}
          initialValues={initialValues}
          setSmsLogin={setSmsLogin}
          smsLogin={smsLogin}
          resendCode={resendCode}
        />
        <div className="text-center" style={{ marginTop: 10 }}>
          <Link to="/reset_password">Forgot your password?</Link>
        </div>
      </div>
    );
}

Login.propTypes = propTypes;

const mapStateToProps = state => ({ ...(state.auth || {}) });
const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(actions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login);
